"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layer = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const react_1 = __importDefault(require("react"));
const StyledHeader = components_core_1.styled.div `
  display: flex;
  justify-content: space-between;
`;
const StyledCloseButtonWrapper = components_core_1.styled.div `
  flex-grow: 0;
`;
function Layer({ closeButton, headline, children }) {
    return (react_1.default.createElement("div", { className: "layer-wrapper" },
        react_1.default.createElement(StyledHeader, { className: "header-wrapper" },
            react_1.default.createElement(components_core_1.Container, { padding: {
                    top: components_core_1.ContainerPadding.static250,
                    left: components_core_1.ContainerPadding.grid001,
                    right: components_core_1.ContainerPadding.static250
                } },
                react_1.default.createElement(components_core_1.Text, { appearance: components_core_1.TokenTextAppearance.headline300, bold: true }, headline)),
            closeButton && (react_1.default.createElement(StyledCloseButtonWrapper, null, closeButton))),
        react_1.default.createElement(components_core_1.Container, { padding: {
                top: components_core_1.ContainerPadding.static250,
                left: components_core_1.ContainerPadding.grid001,
                right: components_core_1.ContainerPadding.grid001,
                bottom: components_core_1.ContainerPadding.static300
            }, gutter: components_core_1.ContainerGutter.static400, wrap: "always" }, children)));
}
exports.Layer = Layer;
